module.exports = __webpack_public_path__ + "img/s1v4t1.26de8c0a.jpeg";